import { useTheme } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { COLORS } from "../styles/colors";

/**
 * A horizontal divider line that can hold text vertically centered on top of the line.
 */
const DividerWithText: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <div
        style={{
          borderBottom: `2px solid ${COLORS.tuv_r_black_10}`,
          width: "100%",
        }}
      />
      <span
        style={{
          paddingTop: theme.spacing(0.5),
          paddingBottom: theme.spacing(0.5),
          paddingRight: theme.spacing(2),
          paddingLeft: theme.spacing(2),
          fontWeight: 500,
          fontSize: 22,
          color: COLORS.tuv_r_black_30,
        }}
      >
        {children}
      </span>
      <div
        style={{
          borderBottom: `2px solid ${COLORS.tuv_r_black_10}`,
          width: "100%",
        }}
      />
    </div>
  );
};
export default DividerWithText;
